import React from 'react';
import {Route} from 'react-router-dom';
import AsyncList from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';
export default [
  <Route
    key="/:type(business)/news/list"
    element={
      <DefaultBusinessLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Business',
            item: '/business',
          },
          {
            position: 3,
            name: 'News List',
            item: '/business/news/list',
          },
        ]}
      />
    }
  >
    <Route path="business/news/list" element={<AsyncList />} />
  </Route>,
];
